import {
  AuthGuard,
  CmsConfig,
  ParamsMapping,
  RoutingConfig,
} from '@spartacus/core';
import {
  ItemService,
  ListService,
  OrganizationTableType,
} from '@spartacus/organization/administration/components';
import { TableConfig } from '@spartacus/storefront';
import { UigBranchRoutePageMetaResolver } from '../services/uig-branch-route-page-meta.resolver';
import { UigBranchesGuard } from '../guards/uig-branches.guard';
import { UigBranchesItemService } from '../services/uig-branches-item.service';
import { UigBranchesListService } from '../services/uig-branches-list.service';
import { UigListService } from '../services/uig-list.service';
import { UigBranchDetailsComponent } from './uig-branch-details/uig-branch-details.component';
import { UigBranchFormComponent } from './uig-branch-form/uig-branch-form.component';
import { UigCellComponent } from './uig-cell/uig-cell.component';
import { UigCheckboxComponent } from './uig-checkbox/uig-checkbox.component';
import { UigListComponent } from './uig-list/uig-list.component';

const listPath = `organization/branches/:${'name'}`;
const paramsMapping: ParamsMapping = {
  name: 'name',
};

export const branchesRoutingConfig: RoutingConfig = {
  routing: {
    routes: {
      branches: {
        paths: ['organization/branches'],
      },
      branchesCreate: {
        paths: ['organization/branches/create'],
      },
      branchesDetails: {
        paths: [listPath],
        paramsMapping,
      },
      branchesEdit: {
        paths: [`${listPath}/edit`],
        paramsMapping,
      },
    },
  },
};

export const branchesCmsConfig: CmsConfig = {
  cmsComponents: {
    ManageBranchesListComponent: {
      component: UigListComponent,
      providers: [
        {
          provide: UigListService,
          useExisting: UigBranchesListService,
        },
        {
          provide: ItemService,
          useExisting: UigBranchesItemService,
        },
        {
          provide: ListService,
          useExisting: UigListService,
        },
      ],
      childRoutes: {
        parent: {
          data: {
            cxPageMeta: {
              breadcrumb: 'breadcrumbs.details',
              resolver: UigBranchRoutePageMetaResolver,
            },
          },
        },
        children: [
          {
            path: 'create',
            component: UigBranchFormComponent,
            data: {
              i18nRoot: 'branchesCreate',
            },
          },
          {
            path: `:${'name'}`,
            component: UigBranchDetailsComponent,
            data: {
              cxPageMeta: { breadcrumb: 'breadcrumbs.child' },
            },
            children: [
              {
                path: 'edit',
                component: UigBranchFormComponent,
                data: {
                  i18nRoot: 'branchesEdit',
                },
              },
            ],
          },
        ],
      },
      guards: [AuthGuard, UigBranchesGuard],
    },
  },
};

export function branchesTableConfigFactory(): TableConfig {
  return branchesTableConfig;
}

export const branchesTableConfig: TableConfig = {
  table: {
    [OrganizationTableType.BRANCHES]: {
      cells: ['name', 'type', 'contactPerson', 'headOffice', 'onlineShop'],
      options: {
        cells: {
          name: {
            dataComponent: UigCellComponent,
          },
          type: {
            dataComponent: UigCellComponent,
          },
          contactPerson: {
            dataComponent: UigCellComponent,
          },
          headOffice: {
            dataComponent: UigCheckboxComponent,
          },
          onlineShop: {
            dataComponent: UigCheckboxComponent,
          },
        },
      },
    },
  },
};
